import { ButtonProps } from '../types/ButtonProps';

/** Primary UI component for user interaction */
export const Button = ({
  className,
  colour,
  circle = false,
  label,
  type = 'button',
  children,
  onClick
}: ButtonProps) => {
  switch (colour) {
    case 'golden':
      colour =
        'bg-golden-light border-golden-light hover:bg-golden-dark hover:border-golden-dark focus:border-none focus:bg-golden-light focus:shadow-circle-golden active:border-none active:bg-golden-light active:shadow-circle-golden';
      break;
    case 'cyan':
      colour =
        'bg-cyan-light border-cyan-light hover:bg-cyan-dark hover:border-cyan-dark focus:border-none focus:bg-cyan-light focus:shadow-circle-cyan active:border-none active:bg-cyan-light active:shadow-circle-cyan';
      break;
    case 'magenta':
      colour =
        'bg-magenta-light border-magenta-light hover:bg-magenta-dark hover:border-magenta-dark focus:border-none focus:bg-magenta-light focus:shadow-circle-magenta active:border-none active:bg-magenta-light active:shadow-circle-magenta';
      break;
    case 'teal':
      colour =
        'bg-teal-light text-white border-teal-light hover:bg-teal-dark hover:border-teal-dark focus:border-none focus:bg-teal-light focus:shadow-circle-teal active:border-none active:bg-teal-light active:shadow-circle-teal';
      break;
    case 'bluestone':
      colour =
        'bg-bluestone-light text-white border-bluestone-light hover:bg-bluestone-dark hover:border-bluestone-dark focus:border-none focus:bg-bluestone-light focus:shadow-circle-bluestone active:border-none active:bg-bluestone-light active:shadow-circle-bluestone';
      break;
    case 'white':
    default:
      colour =
        'bg-white text-bluestone-light border-bluestone-light hover:bg-white-smoke hover:border-bluestone-light focus:border-none focus:text-white focus:bg-bluestone-light focus:shadow-circle-bluestone active:border-none active:bg-bluestone-light active:shadow-circle-bluestone active:text-white';
      break;
  }

  const size = circle ? ' w-14 h-14' : ' px-5 py-4';

  return (
    <button
      type={type}
      className={
        `flex items-center justify-center rounded-full font-bold text-bluestone-light border-2 h-14 select-none ` +
        colour +
        size +
        ' ' +
        className
      }
      onClick={onClick}>
      {label}
      {children}
    </button>
  );
};
